function tabNavigation() {
  const palmaresButtons = document.getElementById("palmares-buttons");
  const palmaresContainer = document.getElementById("palmares-container");
  Array.from(palmaresContainer.children)
    .slice(1)
    .forEach((div) => {
      div.classList.add("hidden");
    });

  let currentClicked = palmaresButtons.children[0];
  currentClicked.classList.add("clicked");
  Array.from(palmaresButtons.children).forEach((button) =>
    button.addEventListener("click", () => {
      if (button !== currentClicked) {
        if (currentClicked) {
          currentClicked.classList.remove("clicked");
        }
        button.classList.add("clicked");
        currentClicked = button;
      }
      button.classList.add("clicked");
      Array.from(palmaresContainer.children).forEach((div) => {
        if (div.id != button.innerText) {
          div.classList.add("hidden");
        } else {
          div.classList.remove("hidden");
        }
      });
    })
  );
}
export default tabNavigation;
